import { usePeeringsSubscription } from "../graphql/generated/operations";
import { formatter } from "../utils/hooks/usePeerings";
import {
  displayedConfiguredASNsAtom,
  displayedConfiguredDataServicesAtom,
  peeringsTableAtom,
} from "../other/store";
import { useData } from "./useData";
import { useAtom } from "jotai";
import { totalNumberOfDataSourcesAtom } from "../store/overviewContent";

export const usePeerings = () => {
  const [
    {
      data: configuredASNs,
      fetching: configuredASNsFetching,
      error: configuredASNsError,
    },
  ] = useAtom(displayedConfiguredASNsAtom);
  const [
    {
      data: configuredDataServices,
      fetching: configuredDataServicesFetching,
      error: configuredDataServicesError,
    },
  ] = useAtom(displayedConfiguredDataServicesAtom);
  const [{ data: totalNumberOfDataSources }] = useAtom(
    totalNumberOfDataSourcesAtom
  );
  const confState = {
    fetching: configuredASNsFetching || configuredDataServicesFetching,
    error: configuredASNsError ?? configuredDataServicesError,
  };

  useData({
    operation: usePeeringsSubscription,
    options: {
      variables: { asns: configuredASNs, dataServices: configuredDataServices },
      pause: !configuredASNs || !configuredDataServices,
    },
    formatter,
    formatterParams: [totalNumberOfDataSources, configuredASNs],
    confState,
    atom: peeringsTableAtom,
  });
};
